import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import StarIcon from '@icons/star_required_icon.svg?component';
import { ITextAreaInputProps } from './types';

export const TextAreaInput: FC<ITextAreaInputProps> = ({
  name,
  label,
  required = false,
  validation,
  asInput = false,
  maxLength,
  classNameProp,
  showRequiredIcon = false,
  placeholder,
  ...props
}) => {
  const formContext = useFormContext();

  const { register, getFieldState } = formContext;

  const valueAs = (val: string) => {
    if (val) return val.trim();
    return val;
  };

  return (
    <div className="relative">
      {label && (
        <div className="label">
          <p>{label}</p>
          {required && showRequiredIcon ? <StarIcon width={12} height={12} /> : null}
        </div>
      )}
      <textarea
        className={`w-full px-4 py-1 border-[1.5px] border-custom-gray rounded-[8px] bg-white leading-7 placeholder:text-[16px] placeholder:text-[rgba(23,30,55,0.3)] resize-y hover:border-[#414042] focus:outline-none focus:ring-0 focus:border-[#414042] ${
          asInput && 'resize-none'
        } ${classNameProp}`}
        style={getFieldState(name).error ? { borderColor: '#E73331' } : {}}
        {...register(name, {
          required,
          validate: validation?.validate,
          setValueAs: valueAs,
          maxLength,
        })}
        placeholder={placeholder}
        aria-label={label || placeholder || name}
        aria-describedby={`${name}-help`}
        {...props}
      />
      <span id={`${name}-help`} className="sr-only">
        {name} help text
      </span>
    </div>
  );
};
